import DesJTViewerViewModel from 'viewmodel/DesJTViewerViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesJTViewer extends DesBaseCatalogAcc {
    constructor() {
        super(DesJTViewerViewModel);
    }

    get src() {
        return this.getAttribute('src');
    }

    getProps() {
        return {
            src: this.src,
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            locale: this.locale
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'src'];
    }
}

if (!window.customElements.get('des-jt-viewer')) {
    window.customElements.define('des-jt-viewer', DesJTViewer);
}
